<template>
  <div>
    <errors :error-list="serverErrors"></errors>

    <div class="card card-body">
      <h4 class="card-title mb-4">Axum</h4>

      <div v-if="isLoading" class="text-center">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>

      <div v-if="!isLoading">
        <!-- Travel Consultant -->
        <div>
          <b>Consultant</b>
          <div class="mt-1" v-if="axumData.consultant">{{ axumData.consultant.username }}</div>
          <div class="mt-1" v-else></div>
        </div>
        <!-- Travel Consultant -->

        <!-- Lead PAX -->
        <div class="mt-3">
          <b>Lead PAX</b>
          <!--                    <div class="mt-1" v-if="leadPax">{{leadPax.firstname}} {{leadPax.lastname}}</div>-->
          <div class="mt-1" v-if="leadPax">{{ leadPax.firstname }} {{ leadPax.surname }}</div>
          <div class="mt-1" v-else>-</div>
        </div>
        <!-- / Lead PAX -->

        <!-- All PAX -->
        <div class="mt-3">
          <b>All PAX</b>
          <div class="mt-2" v-for="passenger in passengers">
            {{ passenger.firstname }} {{ passenger.surname }}
          </div>
        </div>
        <!-- / All PAX -->

        <!-- Dep Date -->
        <div class="mt-3">
          <b>Departure Date</b>
          <div class="mt-1" v-if="axumData.departureDate">{{ formatDate(axumData.departureDate) }}</div>
          <div class="mt-1" v-else>-</div>
        </div>
        <!-- / Dep Date -->

        <!-- Return Date -->
        <div class="mt-3">
          <b>Return Date</b>
          <div class="mt-1" v-if="axumData.returnDate">{{ formatDate(axumData.returnDate) }}</div>
          <div class="mt-1" v-else>-</div>
        </div>
        <!-- / Return Date -->
      </div>
    </div>
  </div>
</template>

<script>
import Forms from "../../../../mixins/Forms";
import Dates from "../../../../mixins/Dates";
import axios from 'axios';

export default {
  props: ['bookingId'],
  name: "AxumDetails",
  mixins: [Forms, Dates],
  data() {
    return {
      isLoading: true,
      serverErrors: [],
      axumData: null
    }
  },
  computed: {
    leadPax() {
      if (this.axumData.leadPassengerId) {
        return _.first(this.axumData.passengers, {
          passengerId: this.axumData.leadPassengerId
        });
      }
      return null;
    },

    passengers() {
      if (this.axumData.passengers) {
        return this.axumData.passengers;
      } else {
        return [];
      }
    }
  },
  created() {
    this.loadAxumData();
  },
  methods: {
    loadAxumData() {
      let vm = this;
      vm.isLoading = true;
      vm.$emit('set-is-axum-loaded', false);

      axios.get(API_BASE + '/axum-search/' + this.bookingId).then(r => {
        // vm.isLoading = false;
        vm.axumData = r.data;
        vm.$emit('axum-data', r.data);
        if (this.leadPax) {
          vm.findOrCreateLeadPaxAsAContact();
        } else {
          vm.isLoading = false;
          vm.$emit('set-is-axum-loaded', true);
        }
      }).catch(e => {
        console.log(e);
        vm.setErrors(e);
        vm.isLoading = false;
        vm.axumData = null;
      });
    },

    findOrCreateLeadPaxAsAContact() {
      let vm = this;
      vm.isLoading = true;
      axios.post(API_BASE + '/contacts/find-or-create', {
        first_name: vm.leadPax.firstname,
        // last_name: vm.leadPax.lastname,
        last_name: vm.leadPax.surname,
        email: vm.leadPax.email
      }).then(r => {
        vm.isLoading = false;
        vm.$emit('set-is-axum-loaded', true);
        vm.$emit('set-primary-contact-from-axum', r.data);
      }).catch(e => {
        vm.isLoading = false;
        vm.$emit('set-is-axum-loaded', true);
      });
    }
  }
}
</script>

<style scoped>
b {
  font-weight: 600;
  color: #2c5cc5;
}
</style>
